import { SVGProps } from 'react'

export const FiatAndSpotLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 3.5a5.502 5.502 0 00-5.302 4.032 7.502 7.502 0 016.77 6.77A5.502 5.502 0 0015 3.5zM14.5 15a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-8 0L9 17.5l2.5-2.5L9 12.5 6.5 15zM9 4H4v5l5-5zm11 16h-5l5-5v5z"
      fill="currentColor"
    ></path>
  </svg>
)

export const OverviewLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4v7h7V4H4zm9 7V4h7v7h-7zm3.5 9.743L12.257 16.5l4.243-4.243 4.243 4.243-4.243 4.243zM4 13h7v7H4v-7z"
      fill="currentColor"
    ></path>
  </svg>
)
export const ChartRiseUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M29,28H4V3A1,1,0,0,0,2,3V29a1,1,0,0,0,1,1H29a1,1,0,0,0,0-2Z" />
    <path d="M7,23a1,1,0,0,0,.66-.25L16,15.37l2.33,2.34a1,1,0,0,0,1.42,0L26,11.41V14a1,1,0,0,0,2,0V9a1,1,0,0,0-1-1H22a1,1,0,0,0,0,2h2.59L19,15.59l-2.29-2.3a1,1,0,0,0-1.37,0l-9,8a1,1,0,0,0-.09,1.41A1,1,0,0,0,7,23Z" />
  </svg>
)

export const ChartRiseDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path d="M29,28H4V3A1,1,0,0,0,2,3V29a1,1,0,0,0,1,1H29a1,1,0,0,0,0-2Z" fill="#4d4d4d" />
    <path
      d="M15.34,17.75a1,1,0,0,0,1.37,0L19,15.41,24.59,21H22a1,1,0,0,0,0,2h5a1,1,0,0,0,1-1V17a1,1,0,0,0-2,0v2.59l-6.29-6.3a1,1,0,0,0-1.42,0L16,15.63,7.66,8.25a1,1,0,0,0-1.32,1.5Z"
      fill="#4d4d4d"
    />
  </svg>
)

export const OilIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#000000" width="800px" height="800px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M450.379,69.456V36.065h-82.365V0h-33.391v36.065H61.621v33.391h21.041v409.153H61.621V512h388.756v-33.391h-21.041V69.456H450.379z M116.055,69.456h279.891v56.102h-0.001h-279.89V69.456z M116.055,158.949h279.891v230.168h-0.001h-279.89V158.949z M116.055,478.609v-56.101h279.891v56.101H116.055z" />
    <path d="M268.398,193.401L256,179.653l-12.398,13.748c-5.014,5.559-48.982,55.472-48.982,95.707c0,33.844,27.536,61.38,61.38,61.38s61.38-27.534,61.38-61.38C317.38,248.873,273.413,198.96,268.398,193.401z M256,317.097c-15.433,0-27.989-12.555-27.989-27.989c0-10.765,6.857-27.02,19.306-45.771c2.977-4.483,5.975-8.657,8.737-12.33c13.693,18.26,27.934,42.324,27.934,58.101C283.989,304.541,271.434,317.097,256,317.097z" />
  </svg>
)

export const PlanetIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="600px" height="600px" viewBox="0 0 42.36 42.36" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      fill="#030104"
      d="M21.18,0C9.501,0,0,9.501,0,21.18c0,11.68,9.501,21.18,21.18,21.18c11.68,0,21.18-9.5,21.18-21.18
			C42.36,9.501,32.86,0,21.18,0z M21.18,40.86c-10.852,0-19.68-8.828-19.68-19.68S10.328,1.5,21.18,1.5s19.68,8.828,19.68,19.68
			S32.032,40.86,21.18,40.86z"
    />
    <path
      fill="#030104"
      d="M39.61,16.143c-0.103-0.367-0.426-0.983-1.459-0.983l-0.213,0.006c-0.059,0-0.124-0.007-0.193-0.02
			c-0.172-0.035-0.483-0.174-0.734-0.286c-0.184-0.081-0.357-0.158-0.505-0.213c-1.421-0.529-2.493-0.259-3.589,0.896
			c-0.303,0.315-0.704,0.858-0.971,1.256c-1.179,1.768-1.134,2.91,0.161,4.074c0.25,0.223,0.604,0.613,1.021,1.073
			c1.25,1.377,3.14,3.457,5.454,4.618l0.121,0.06l0.229,0.024c0.263,0,0.763-0.173,0.765-0.769c0.387-1.528,0.583-3.109,0.583-4.699
			C40.28,19.472,40.053,17.778,39.61,16.143z M38.418,24.746c-1.713-1.092-3.19-2.719-4.187-3.816
			c-0.456-0.503-0.817-0.9-1.122-1.174c-0.572-0.515-0.834-0.749,0.084-2.126c0.227-0.339,0.576-0.811,0.81-1.055
			c0.575-0.605,0.993-0.676,1.257-0.676c0.21,0,0.441,0.049,0.727,0.153c0.107,0.04,0.234,0.097,0.42,0.181
			c0.351,0.155,0.713,0.316,1.049,0.383c0.16,0.032,0.317,0.079,0.49,0.049l0.213-0.006c0.014,0,0.025,0,0.037,0.001
			c0.386,1.467,0.584,2.987,0.584,4.52C38.78,22.379,38.659,23.576,38.418,24.746z"
    />
    <path
      fill="#030104"
      d="M32.771,13.222c0.38,0.289,0.862,0.369,1.283,0.21c0.396-0.145,0.632-0.469,0.806-0.802
			c0.707,0.828,1.436,1.136,1.942,1.245c0.09,0.02,0.183,0.03,0.272,0.03c0.394,0,0.746-0.196,0.943-0.525
			c0.217-0.361,0.215-0.82-0.004-1.227c-0.91-1.694-2.068-3.238-3.441-4.589C34.326,7.322,34,7.189,33.65,7.189
			c-0.512,0-0.959,0.277-1.171,0.723c-0.392,0.827-0.804,2.133-0.542,3.658C31.959,11.691,32.157,12.75,32.771,13.222z
			 M33.755,8.868c0.829,0.848,1.602,1.803,2.302,2.853c-0.134-0.149-0.271-0.33-0.408-0.547c-0.291-0.462-0.64-0.559-0.881-0.559
			c-0.638,0-0.9,0.584-1.093,1.012c-0.039,0.088-0.072,0.155-0.099,0.206c-0.062-0.135-0.127-0.32-0.16-0.517
			C33.23,10.224,33.518,9.358,33.755,8.868z"
    />
    <path
      fill="#030104"
      d="M21.179,6.034c0.176,0.016,0.396,0.023,0.626,0.023c0.348,0,0.712-0.018,0.977-0.047
			c1.795-0.201,2.684-0.954,3.112-1.551c0.246-0.343,0.3-0.764,0.146-1.154c-0.164-0.422-0.555-0.743-1.017-0.838
			c-2.307-0.468-4.753-0.507-7.078-0.113c-0.48,0.082-0.846,0.381-0.978,0.799c-0.129,0.405-0.009,0.843,0.319,1.17
			C17.979,5.014,19.215,5.872,21.179,6.034z M24.401,3.876c-0.324,0.273-0.871,0.541-1.787,0.644
			c-0.344,0.036-0.945,0.048-1.312,0.021c-0.925-0.078-1.728-0.351-2.394-0.814C20.725,3.492,22.614,3.544,24.401,3.876z"
    />
    <path
      fill="#030104"
      d="M22.991,24.628c-1.621,0.163-3.713-0.206-4.483-0.722c-0.064-0.059-0.224-0.396-0.232-0.677
			c-0.048-1.397,0.829-1.44,1.117-1.454c1.24-0.058,2.031-0.521,2.476-0.9c0.547-0.467,0.799-1.341,0.856-1.739
			c0.073-0.525,0.123-1.128,0.149-1.789c0.064-1.744,0.432-2.767,1.006-2.807c1.723-0.12,1.9-1.112,1.883-1.843
			c0-0.53-0.348-0.807-0.654-1.052c-0.302-0.24-0.758-0.604-1.373-1.456c-1.181-1.634-2.748-3.267-6.194-4.147
			c-0.851-0.217-1.691-0.327-2.497-0.327c-1.968,0-3.464,0.644-4.667,1.272C10.066,7.15,9.779,7.24,9.572,7.24
			c-0.028,0-0.054-0.002-0.086-0.005C9.301,7.213,9.102,7.19,8.911,7.19c-0.502,0-0.889,0.143-1.185,0.436
			C7.284,8.066,6.87,8.518,6.494,8.971C6.01,9.552,5.92,10.566,6.56,11.15c0.652,0.589,1.516,0.799,2.394,0.589
			c0.853-0.205,1.264-0.034,1.264,0.639c0,0.209-0.051,0.605-0.116,1.105c-0.215,1.65-0.539,4.143,0.211,6.096l0.089,0.231
			c0.89,2.334,2.975,7.799,7.924,8.309c1.723,0.179,3.024,0.269,3.871,0.269l0.149-0.001c0.026,0,0.052,0.004,0.071,0.01
			c-0.006,0.407-0.104,1.033-0.495,1.846c-1.244,2.578,0.325,5.484,4.803,8.885c0.257,0.193,0.547,0.293,0.863,0.293
			c0.668,0,1.231-0.434,1.78-0.852l0.131-0.102c0.541-0.408,0.894-1.139,0.857-1.773c-0.051-0.899-0.16-3.082-0.098-3.899
			c0.018-0.222,0.068-0.458,0.126-0.73c0.217-1.032,0.514-2.446-0.572-4.54C28.655,25.291,26.334,24.307,22.991,24.628z"
    />
  </svg>
)

export const ListTaskIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    {/* В оригинале пути продублированы — оставил по одному экземпляру */}
    <path d="M14.563,17.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z" />
    <path d="M14.563,33.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z" />
    <path d="M14.563,49.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z" />
  </svg>
)

export const VolatileChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 22H22"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 4V22H14.25V4C14.25 2.9 13.8 2 12.45 2H11.55C10.2 2 9.75 2.9 9.75 4Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10V22H7V10C7 8.9 6.6 8 5.4 8H4.6C3.4 8 3 8.9 3 10Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 15V22H21V15C21 13.9 20.6 13 19.4 13H18.6C17.4 13 17 13.9 17 15Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AnvilIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 512.004 512.004"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    height="800px"
    width="800px"
    {...props}
  >
    <path
      d="M504.396,141.431H173.45H7.604c-4.2,0-7.604,3.405-7.604,7.604c0,8.871,1.484,17.501,4.355,25.797
      c0.087,0.302,0.188,0.599,0.31,0.885c8.248,22.977,27.26,43.321,55.54,58.864c38.699,21.268,92.742,32.838,156.607,33.575
      l-54.217,59.898c-1.265,1.398-1.966,3.217-1.966,5.103v29.815c0,0.292,0.02,0.578,0.052,0.861c0.009,0.075,0.023,0.149,0.034,0.224
      c0.03,0.211,0.067,0.421,0.115,0.626c0.018,0.08,0.041,0.159,0.062,0.239c0.054,0.202,0.115,0.399,0.183,0.594
      c0.026,0.073,0.052,0.147,0.08,0.219c0.081,0.208,0.172,0.411,0.271,0.609c0.026,0.053,0.049,0.106,0.076,0.159
      c0.262,0.498,0.577,0.962,0.938,1.387c0.055,0.065,0.114,0.126,0.171,0.188c0.132,0.145,0.268,0.285,0.41,0.419
      c0.069,0.065,0.139,0.129,0.211,0.192c0.154,0.135,0.313,0.262,0.479,0.384c0.045,0.032,0.083,0.071,0.128,0.102
      c0.015,0.01,0.032,0.017,0.048,0.028c0.287,0.201,0.59,0.38,0.904,0.54c0.054,0.027,0.109,0.053,0.163,0.079
      c0.63,0.302,1.305,0.519,2.017,0.639c0.073,0.012,0.146,0.023,0.219,0.033c0.343,0.048,0.69,0.08,1.046,0.08h331.243
      c0.02,0,0.039-0.003,0.059-0.003c0.078,0,0.155-0.009,0.233-0.012c0.21-0.008,0.419-0.021,0.623-0.046
      c0.087-0.01,0.172-0.026,0.259-0.04c0.201-0.031,0.398-0.069,0.593-0.116c0.082-0.019,0.163-0.041,0.244-0.063
      c0.206-0.057,0.408-0.122,0.606-0.195c0.067-0.024,0.134-0.047,0.201-0.073c0.249-0.099,0.493-0.21,0.728-0.335
      c0.014-0.007,0.028-0.013,0.043-0.02c0.255-0.137,0.499-0.288,0.735-0.452c0.014-0.01,0.03-0.017,0.045-0.027
      c0.043-0.03,0.08-0.067,0.123-0.097c0.17-0.126,0.337-0.255,0.496-0.394c0.072-0.063,0.143-0.128,0.212-0.193
      c0.14-0.132,0.275-0.27,0.405-0.412c0.061-0.066,0.123-0.131,0.18-0.199c0.162-0.191,0.315-0.388,0.459-0.594
      c0.014-0.02,0.031-0.04,0.046-0.061c0.159-0.234,0.304-0.479,0.437-0.731c0.026-0.05,0.048-0.1,0.073-0.151
      c0.1-0.202,0.194-0.408,0.277-0.619c0.028-0.073,0.054-0.146,0.08-0.22c0.069-0.195,0.131-0.392,0.185-0.594
      c0.021-0.081,0.044-0.161,0.063-0.242c0.048-0.206,0.084-0.415,0.115-0.626c0.011-0.076,0.026-0.15,0.034-0.227
      c0.032-0.284,0.053-0.572,0.053-0.864v-29.815c0-1.886-0.701-3.705-1.966-5.103l-55.315-61.112l60.382-70.731
      c1.175-1.377,1.821-3.127,1.821-4.938v-42.24C512,144.835,508.596,141.431,504.396,141.431z M15.668,156.639h150.178v8.485H17.312
      C16.573,162.328,16.017,159.5,15.668,156.639z M67.529,221.252c-20.637-11.341-35.593-25.344-44.105-40.92h142.422v10.943
      c0,1.595,0.501,3.149,1.433,4.443l41.079,57.057C150.788,251.184,102.323,240.374,67.529,221.252z M212.812,355.368l123.465-43.381
      l119.85,43.381H212.812z M496.792,188.47l-62.901,73.682c-2.482,2.908-2.42,7.206,0.146,10.04l57.835,63.895v16.045l-152.968-55.369
      c-1.649-0.597-3.454-0.606-5.109-0.023l-157.958,55.501v-16.154l57.835-63.895c2.406-2.658,2.629-6.636,0.533-9.547l-53.151-73.824
      v-8.491h315.738V188.47z M496.792,165.124H181.054v-8.485h315.738V165.124z"
    />
  </svg>
)

export const EnergyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="800px"
    height="800px"
    {...props}
  >
    <path
      d="M424.97,168.97c0.008-46.627-18.929-88.94-49.494-119.482C344.94,18.93,302.62-0.008,256,0
      c-46.619-0.008-88.94,18.93-119.474,49.495C105.96,80.03,87.023,122.343,87.03,168.97c-0.007,31.187,8.51,60.472,23.298,85.538
      c0.008,0.008,0.016,0.015,0.016,0.015c0.047,0.094,0.094,0.189,0.142,0.267l0.015-0.007c10.372,18.449,25.294,36.702,37.41,54.122
      c6.082,8.714,11.433,17.169,15.134,24.9c3.732,7.74,5.704,14.654,5.791,20.21v93.623c0.008,28.892,23.408,52.292,52.3,52.3h10.552
      C237.338,507.223,246.076,512,256,512c9.924,0,18.662-4.777,24.312-12.061h10.552c28.893-0.008,52.293-23.408,52.3-52.3V341.695
      h-12.069H191.332c-1.438-6.27-3.677-12.376-6.521-18.332c-6.954-14.427-17.02-28.382-26.983-42.006
      c-9.972-13.57-19.856-26.794-26.41-38.597l-0.11-0.196l-0.055-0.079c-12.76-21.545-20.076-46.618-20.084-73.515
      c0.008-40.034,16.194-76.164,42.423-102.408C179.836,40.325,215.966,24.147,256,24.138c40.034,0.008,76.164,16.187,102.408,42.424
      c26.228,26.244,42.415,62.373,42.422,102.408c-0.007,26.897-7.323,51.97-20.091,73.515l-0.087,0.15l-0.086,0.157
      c-9.885,17.828-22.984,30.417-37.332,38.683c-14.34,8.25-29.992,12.124-44.709,12.124c-17.169,0.016-32.884-5.288-43.838-14.34
      c-5.5-4.526-9.86-9.963-12.909-16.32c-3.042-6.365-4.801-13.704-4.809-22.307c0-0.88,0.181-1.886,0.22-2.798
      c18.521-16.579,69.454-15.354,79.833-70.2c6.593-34.896-11.676-63.639-14.748-84.485c-93.875-8.046-136.785,76.438-91.816,143.424
      c1.179,1.752,2.145,3.135,2.962,4.384c-0.345,3.276-0.589,6.514-0.589,9.673c-0.008,11.967,2.53,23.046,7.174,32.726
      c6.961,14.56,18.528,25.797,32.271,33.198c13.759,7.426,29.718,11.174,46.25,11.182c18.913-0.008,38.651-4.943,56.747-15.346
      c18.002-10.34,34.298-26.166,46.234-47.601c0.008-0.015,0.016-0.032,0.031-0.047c0.048-0.094,0.102-0.173,0.15-0.26l-0.008-0.007
      C416.468,229.418,424.978,200.148,424.97,168.97z M192.974,365.834h126.051v37.575l-126.051-26.802V365.834z M192.974,393.06
      l126.051,26.803v27.776c0,1.721-0.212,3.387-0.503,5.014L192.974,425.96V393.06z M192.974,442.422l117.864,25.058
      c-0.024,0.024-0.04,0.047-0.064,0.071c-5.13,5.116-12.093,8.242-19.911,8.25h-69.728c-7.818-0.008-14.78-3.135-19.911-8.25
      c-5.115-5.131-8.242-12.093-8.25-19.911V442.422z M228.514,199.771c0-6.49,0-17.318,11.912-48.732
      c11.912-31.407,42.234-51.978,44.402-47.649c-37.896,45.488-45.778,97.568-46.571,100.719
      C237.174,208.446,228.514,206.277,228.514,199.771z"
    />
  </svg>
)

export const GoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 440.13 440.13"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="800px"
    height="800px"
    {...props}
  >
    <path
      d="M414.884,130.163H379.31v14.336h21.238v194.217h-61.384v-14.408h-14.336v14.408l-10.916,21.827v-36.239h-14.336v79.391
      H440.13V180.662L414.884,130.163z M315.535,389.358l18.084-36.163h72.484l18.084,36.163H315.535z M425.8,360.543h0l-10.916-21.827
      V162.219l10.916,21.827V360.543z"
    />
    <path
      d="M275.83,360.532l-10.911-21.816v-14.408h-14.336v14.408h-61.384v-14.408h-14.336v14.408l-10.916,21.827v-36.239h-14.336
      v79.391h140.554v-79.391H275.83V360.532z M165.571,389.358l18.084-36.163h72.484l18.084,36.163H165.571z"
    />
    <path
      d="M364.974,86.93h0.005l-25.252-50.499h-90.056L224.42,86.93v223.037h140.554V86.93z M264.008,50.772h61.384v194.217h-61.384
      V50.772z M238.756,90.319l10.916-21.827v176.497l-10.916,21.821V90.319z M240.374,295.631l18.084-36.163h72.484l18.084,36.163
      H240.374z M350.643,266.811h0l-10.916-21.827V68.488l10.916,21.827V266.811z"
    />
    <path
      d="M126.218,360.543l-10.916-21.827v-14.408h-14.336v14.408H39.588V144.499h20.89v-14.336H25.252L0,180.662v223.037h140.554
      v-79.396h-14.336V360.543z M14.336,184.046l10.916-21.827v176.497l-10.916,21.827V184.046z M15.954,389.358l18.084-36.163h72.484
      l18.084,36.163H15.954z"
    />
    <path
      d="M215.357,86.93h0.005l-25.252-50.499h-90.056L74.803,86.93v223.037h140.554V86.93z M114.391,50.772h61.389v194.217h-61.389
      V50.772z M89.144,90.319l10.916-21.827v176.497l-10.916,21.827V90.319z M90.762,295.631l18.084-36.163h72.484l18.084,36.163
      H90.762z M201.027,266.811l-10.916-21.827V68.488l10.916,21.827V266.811z"
    />
  </svg>
)

export const LeafsFromEarchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="800px"
    height="800px"
    {...props}
  >
    <path
      d="M465.277,485.664c-14.937-30.378-38.021-55.89-66.757-73.782c-27.237-16.96-58.382-26.324-90.383-27.257V236.699
      c4.785,0.654,9.673,0.988,14.636,0.988c27.644,0,57.511-10.035,83.936-28.808c35.292-25.073,57.883-61.063,60.43-96.273
      c0.644-8.897-5.113-17.001-13.727-19.322c-34.086-9.185-75.507,0.298-110.8,25.371c-13.485,9.58-25.108,20.757-34.474,32.873V19.177
      c0-10.283-8.337-18.62-18.621-18.62s-18.621,8.337-18.621,18.62v32.052c-12.338-14.404-28.601-26.898-47.595-36.108
      c-36.456-17.676-76.194-19.998-106.3-6.212c-8.11,3.714-12.447,12.658-10.341,21.327c7.819,32.175,34.252,61.938,70.708,79.615
      c20.697,10.035,42.449,15.121,62.899,15.121c10.677,0,20.999-1.388,30.628-4.181v124.113
      c-14.298-20.759-33.225-39.944-55.853-56.018c-50.076-35.575-108.563-49.104-156.456-36.2
      c-8.613,2.321-14.37,10.425-13.727,19.322c3.578,49.472,35.61,100.245,85.684,135.819c37.596,26.708,79.927,40.991,118.963,40.991
      c7.262,0,14.405-0.514,21.388-1.514v37.354c-31.531,1.151-62.186,10.501-89.045,27.223c-28.735,17.892-51.82,43.404-66.756,73.782
      c-2.838,5.771-2.496,12.348,0.904,17.807c3.4,5.46,9.375,8.528,15.806,8.528h316.761c6.432,0,12.407-3.069,15.806-8.528
      C467.772,498.012,468.115,491.436,465.277,485.664z M364.18,149.015c19.817-14.078,42.285-21.825,62.096-21.916
      c-6.61,18.676-21.318,37.343-41.135,51.421c-19.817,14.078-42.285,21.823-62.097,21.916
      C329.653,181.759,344.361,163.092,364.18,149.015z M193.617,76.342c-19.296-9.356-34.942-23.252-43.891-38.396
      c17.429-2.351,38.031,1.328,57.328,10.684c19.296,9.356,34.942,23.252,43.891,38.394
      C233.516,89.377,212.913,85.698,193.617,76.342z M152.114,277.47c-34.727-24.67-59.427-58.651-67.494-91.752
      c33.911-3.276,74.132,8.861,108.856,33.529c34.727,24.67,59.427,58.651,67.494,91.752
      C227.059,314.277,186.836,302.137,152.114,277.47z M165.549,474.759c26.892-33.517,67.561-53.379,111.969-53.379h25.334
      c44.407,0,85.077,19.862,111.969,53.379H165.549z"
    />
  </svg>
)

export const AgroCultureIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      d="M16 16c-3.3 0-6-2.7-6-6 3.3 0 6 2.7 6 6z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16c3.3 0 6-2.7 6-6-3.3 0-6 2.7-6 6z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 13.2c2.3-2.3 2.3-6.1 0-8.5-2.3 2.4-2.3 6.2 0 8.5z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21c-3.3 0-6-2.7-6-6 3.3 0 6 2.7 6 6z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21c3.3 0 6-2.7 6-6-3.3 0-6 2.7-6 6z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 26c-3.3 0-6-2.7-6-6 3.3 0 6 2.7 6 6z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 26c3.3 0 6-2.7 6-6-3.3 0-6 2.7-6 6z"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <line x1={16} y1={31} x2={16} y2={26} stroke="#000" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={16} y1={5} x2={16} y2={1} stroke="#000" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={21} y1={10} x2={21} y2={4} stroke="#000" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={11} y1={10} x2={11} y2={4} stroke="#000" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export const SettingsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px" {...props}>
    <path d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z" />
  </svg>
)

export const ShareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#EBEBEB" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px" {...props}>
    <path d="M 41 2 C 37.145851 2 34 5.1458514 34 9 C 34 10.842988 34.724355 12.518937 35.896484 13.771484 L 27.525391 24 L 15.919922 24 C 15.430748 20.617539 12.513828 18 9 18 C 5.1458514 18 2 21.145851 2 25 C 2 28.854149 5.1458514 32 9 32 C 12.513828 32 15.430748 29.382461 15.919922 26 L 27.501953 26 L 35.535156 36.640625 C 34.5767 37.838633 34 39.353257 34 41 C 34 44.854149 37.145851 48 41 48 C 44.854149 48 48 44.854149 48 41 C 48 37.145851 44.854149 34 41 34 C 39.515247 34 38.13907 34.471256 37.003906 35.265625 L 29.271484 25.025391 L 37.455078 15.021484 C 38.496931 15.638103 39.706395 16 41 16 C 44.854149 16 48 12.854149 48 9 C 48 5.1458514 44.854149 2 41 2 z M 41 4 C 43.773268 4 46 6.2267316 46 9 C 46 11.773268 43.773268 14 41 14 C 38.226732 14 36 11.773268 36 9 C 36 6.2267316 38.226732 4 41 4 z M 9 20 C 11.773268 20 14 22.226732 14 25 C 14 27.773268 11.773268 30 9 30 C 6.2267316 30 4 27.773268 4 25 C 4 22.226732 6.2267316 20 9 20 z M 41 36 C 43.773268 36 46 38.226732 46 41 C 46 43.773268 43.773268 46 41 46 C 38.226732 46 36 43.773268 36 41 C 36 38.226732 38.226732 36 41 36 z" />
  </svg>
)

export const ReportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <g>
        <path
          d="M8.5,9C8.2,9,8,9.2,8,9.5V10c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3h0.5c0.3,0,0.5-0.2,0.5-0.5C12,10.6,10.4,9,8.5,9z
             M9,10.1c1,0.2,1.8,1,1.9,1.9H9V10.1z M8,15c-1.1,0-2-0.9-2-2s0.9-2,2-2v1.5C8,12.8,8.2,13,8.5,13H10C10,14.1,9.1,15,8,15z"
        />
      </g>
      <g>
        <path
          d="M17.5,22h-11C5.7,22,5,21.3,5,20.5v-2C5,17.7,5.7,17,6.5,17h11c0.8,0,1.5,0.7,1.5,1.5v2C19,21.3,18.3,22,17.5,22z
          M6.5,18C6.2,18,6,18.2,6,18.5v2C6,20.8,6.2,21,6.5,21h11c0.3,0,0.5-0.2,0.5-0.5v-2c0-0.3-0.2-0.5-0.5-0.5H6.5z"
        />
      </g>
      <g>
        <path d="M18.5,16h-6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5S18.8,16,18.5,16z" />
      </g>
      <g>
        <path d="M18.5,14h-5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5S18.8,14,18.5,14z" />
      </g>
      <g>
        <path d="M18.5,12h-5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5S18.8,12,18.5,12z" />
      </g>
      <g>
        <path d="M18.5,10h-6C12.2,10,12,9.8,12,9.5S12.2,9,12.5,9h6C18.8,9,19,9.2,19,9.5S18.8,10,18.5,10z" />
      </g>
      <g>
        <path d="M18.5,8h-6C12.2,8,12,7.8,12,7.5S12.2,7,12.5,7h6C18.8,7,19,7.2,19,7.5S18.8,8,18.5,8z" />
      </g>
      <path
        d="M19.5,0h-8.6c-0.4,0-0.8,0.2-1.1,0.4L3.4,6.9C3.2,7.1,3,7.5,3,7.9v14.6C3,23.3,3.7,24,4.5,24h15c0.8,0,1.5-0.7,1.5-1.5v-21
        C21,0.7,20.3,0,19.5,0z M11,3h6.5C17.8,3,18,3.2,18,3.5v1C18,4.8,17.8,5,17.5,5H11V3z M10,1.7v4.8C10,6.8,9.8,7,9.5,7H4.7L10,1.7z
         M20,22.5c0,0.3-0.2,0.5-0.5,0.5h-15C4.2,23,4,22.8,4,22.5V8h5.5C10.3,8,11,7.3,11,6.5V6h6.5C18.3,6,19,5.3,19,4.5v-1
        C19,2.7,18.3,2,17.5,2H11V1h8.5C19.8,1,20,1.2,20,1.5V22.5z"
      />
    </g>
  </svg>
)

export const PortfolioIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="#000000"
    strokeWidth={0.896}
    {...props}
  >
    <path d="m26.5 36-13.1-.81a4 4 0 0 1-3.76-3.58L8.47 20.42a4 4 0 0 1 4-4.42h39.09a4 4 0 0 1 4 4.42l-1.2 11.19a4 4 0 0 1-3.76 3.58L37.5 36" />
    <path d="M52 34.92V48a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V34.85" />
    <path d="M27 16v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" />
    <rect x="26.5" y="33.25" width="11" height="5.5" rx="2.75" />
  </svg>
)

export const CryptoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Bitcoin">
      <g>
        <path d="M12,21.934A9.934,9.934,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.934ZM12,3.066A8.934,8.934,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.066Z" />
        <path d="M14.28,11.78A1.994,1.994,0,0,0,12.75,8.5H12.5V7.47A.489.489,0,0,0,12,7a.483.483,0,0,0-.5.47V8.5H10.25a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1H11.5v1.03A.483.483,0,0,0,12,17a.489.489,0,0,0,.5-.47V15.5h.75a2.006,2.006,0,0,0,2-2A2.033,2.033,0,0,0,14.28,11.78ZM10.25,9.5h2.5a1,1,0,0,1,0,2h-2.5Zm3,5h-3v-2h3a1,1,0,0,1,0,2Z" />
      </g>
    </g>
  </svg>
)

export const RocketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>rocket-launch</title>
    <path d="M30.748 1.948c-0.026-0.38-0.333-0.68-0.713-0.697l-0.002-0c-6.141-0.269-11.588 2.375-16.457 7.999h-9.576c-0.35 0-0.643 0.239-0.726 0.563l-0.001 0.005-2 8c-0.014 0.054-0.022 0.117-0.022 0.181 0 0.414 0.335 0.75 0.75 0.751h5.302c-0.328 0.628-0.655 1.259-0.977 1.922-0.047 0.096-0.075 0.209-0.075 0.328 0 0.207 0.084 0.395 0.22 0.532l4 4c0.136 0.135 0.323 0.219 0.53 0.219h0c0.124-0 0.24-0.030 0.343-0.082l-0.004 0.002q0.962-0.487 1.911-0.989v5.476c0 0.001 0 0.001 0 0.002 0 0.413 0.335 0.748 0.748 0.748 0.001 0 0.001 0 0.002 0h-0c0.065-0 0.127-0.008 0.187-0.023l-0.006 0.001 8-2c0.329-0.085 0.568-0.379 0.568-0.728v-9.585c5.103-4.212 8.495-9.449 7.998-16.623zM2.961 17.25l1.625-6.5h7.759c-1.463 1.889-2.864 4.014-4.101 6.242l-0.131 0.258zM21.25 27.57l-6.5 1.625v-5.331c2.51-1.373 4.634-2.737 6.658-4.231l-0.158 0.111zM11.146 24.084l-3.236-3.236c6.019-12.18 12.987-18.116 21.274-18.116l0.104 0.001c0.328 10.329-8.441 16.387-18.142 21.352zM23 6.25c-1.519 0-2.75 1.231-2.75 2.75s1.231 2.75 2.75 2.75c1.519 0 2.75-1.231 2.75-2.75v0c-0.002-1.518-1.232-2.748-2.75-2.75h-0zM23 10.25c-0.69 0-1.25-0.56-1.25-1.25s0.56-1.25 1.25-1.25c0.69 0 1.25 0.56 1.25 1.25v0c-0.001 0.69-0.56 1.249-1.25 1.25h-0zM4.48 24.252l-0.476-0.002c-0.359 0.072-0.587 0.186-0.701 0.471l-2 5c-0.034 0.082-0.053 0.178-0.053 0.278 0 0.414 0.335 0.75 0.75 0.751h0c0.1-0 0.196-0.020 0.284-0.055l-0.005 0.002 5.004-1.996c0.267-0.11 0.455-0.361 0.471-0.658l0-0.002c0.021-0.404 0.048-0.754 0.071-1.055 0.078-1.006 0.13-1.672-0.33-2.172-0.508-0.551-1.241-0.555-3.014-0.563zM6.329 26.871c-0.015 0.186-0.031 0.389-0.046 0.613l-2.938 1.172 1.161-2.904c0.896 0.004 1.733 0.008 1.85 0.027 0.011 0.125 0.017 0.27 0.017 0.417 0 0.238-0.016 0.472-0.047 0.702l0.003-0.027z" />
  </svg>
)

export const HeartOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FavouritesStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z"
      stroke="#1C274C"
      strokeWidth="1.5"
    />
  </svg>
)

export const ChartArrowDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="800px" height="800px" viewBox="0 -3 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5858 8L9 4.4142L6.7071 6.7071C6.3166 7.0976 5.68342 7.0976 5.29289 6.7071L0.29289 1.70711C-0.09763 1.31658 -0.09763 0.68342 0.29289 0.29289C0.68342 -0.09763 1.31658 -0.09763 1.70711 0.29289L6 4.5858L8.2929 2.29289C8.6834 1.90237 9.3166 1.90237 9.7071 2.29289L14 6.5858V4C14 3.4477 14.4477 3 15 3C15.5523 3 16 3.4477 16 4V9C16 9.5523 15.5523 10 15 10H10C9.4477 10 9 9.5523 9 9C9 8.4477 9.4477 8 10 8H12.5858z"
    />
  </svg>
)

export const MonitorChartIcon = ({ color, ...props }: SVGProps<SVGSVGElement> & { color?: string }) => {
  const strokeColor = color || '#000000'

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 104.03 104.03"
      fill="none"
      stroke={strokeColor}
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Монитор — основная рамка */}
      <path d="M9.35 77.01h85.33c2.21 0 4-1.79 4-4V23.54c0-2.21-1.79-4-4-4H9.35c-2.21 0-4 1.79-4 4v49.47c0 2.21 1.79 4 4 4Z" />
      <path d="M9.35 23.54h85.33v49.47H9.35V23.54Z" />

      {/* Подставка монитора */}
      <path d="M103.02 79.42H1.04c-.4 0-.75.23-.92.59-.18.4-.15.84.09 1.22 16.06.8 28.16 1.05 34.06 1.05 11.57 0 49.54-.23 52.21-3.15.26-.28.39-.64.35-1-.05-.52-.48-.92-1.02-.92Z" />

      {/* График внутри монитора — все линии теперь stroke */}
      <g>
        {/* Линия графика */}
        <polyline points="18.76 46.87 36.26 45.62 50.09 57.58 61.97 47.24 74.8 53.24 85.28 40.77" />

        {/* Кружки на точках графика */}
        <circle cx="18.76" cy="46.87" r="2.8" />
        <circle cx="36.26" cy="45.62" r="2.8" />
        <circle cx="50.09" cy="57.58" r="2.8" />
        <circle cx="61.97" cy="47.24" r="2.8" />
        <circle cx="74.8" cy="53.24" r="2.8" />
        <circle cx="85.28" cy="40.77" r="2.8" />
      </g>
    </svg>
  )
}

export const MarginLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.768 7.019L5.828 19.958 4.062 18.19 17 5.25l.883.885.884.884z"
      fill="currentColor"
    ></path>
    <path d="M12 4h8v8l-8-8z" fill="currentColor"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0-5.031L5.969 7.5 7.5 9.031l1.531-1.53L7.5 5.968zM16.5 20a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0-5.031L14.969 16.5l1.531 1.531 1.531-1.53-1.531-1.532z"
      fill="currentColor"
    ></path>
  </svg>
)

export const FeaturesLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 3H20v13a4 4 0 01-4 4H7.5A3.5 3.5 0 014 16.5V9h4.5V3zM11 14.506v2.5h6.5v-2.5H11zM8.5 11.5h-2v5a1 1 0 102 0v-5zm4-5.494h5v5L15.885 9.39l-2.616 2.616-1.768-1.768 2.616-2.616L12.5 6.006z"
      fill="currentColor"
    ></path>
  </svg>
)

export const OptionsLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 3H8.5v6H4v7.5A3.5 3.5 0 007.5 20H16a4 4 0 004-4V3zM6.5 11.5h2v5a1 1 0 11-2 0v-5zm10.364 3.75H11.66v-7.5h5.203v1.7h-3.328v1.164h2.854v1.69h-2.854v1.246h3.328v1.7z"
      fill="currentColor"
    ></path>
  </svg>
)

export const FundingLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-4l4 4-4 4-4-4 4-4z"
      fill="currentColor"
    ></path>
  </svg>
)

export const EarnLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.014 1a4.912 4.912 0 00-4.218 7.431 6.703 6.703 0 00-4.006 5.717H2v1.786h1.915a6.704 6.704 0 002.758 4.155l-1.648 1.648L6.287 23l2.07-2.07a6.694 6.694 0 002.118.342h5.304l1.591 1.591 1.263-1.262-1.34-1.34 4.35-4.35v-2.687h-1.934a6.126 6.126 0 00-1.398-2.915l2.435-2.435h-4.228A4.912 4.912 0 0012.014 1zM8.888 5.912a3.126 3.126 0 116.251 0 3.126 3.126 0 01-6.251 0zm1.786 0l1.34-1.34 1.34 1.34-1.34 1.34-1.34-1.34zm-.926 7.322h4.53v-1.786h-4.53v1.786z"
      fill="currentColor"
    ></path>
  </svg>
)

export const TransactionHistoryLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.597 16.594A6.48 6.48 0 0112 18.498h-1.25v2.5H12a9 9 0 006.364-15.364 9 9 0 00-12.728 0l1.767 1.768a6.5 6.5 0 019.193 9.192zM13.25 8h-2.5v4.518l3.185 3.185 1.768-1.768-2.453-2.453V8zM5.627 9.568v1.2l-.092.006c-.767.062-1.371.29-1.783.662-.41.37-.639.891-.639 1.564 0 .684.24 1.223.676 1.642.438.421 1.08.726 1.889.925l.076.019v1.901l-.123-.029a3.94 3.94 0 01-.838-.305 2.512 2.512 0 01-.596-.4L3.14 17.935c.446.416 1.309.784 2.268.974l.08.016v1.277h1.578v-1.207l.086-.011c.796-.11 1.357-.448 1.718-.891a2.457 2.457 0 00.532-1.562c0-.669-.246-1.177-.668-1.568-.426-.394-1.037-.675-1.772-.874l-.074-.02v-1.802l.125.033c.406.106.816.31 1.099.558l1.035-1.136c-.43-.4-1.102-.697-1.875-.861l-.08-.017V9.568H5.628zm.19 4.272l-.137-.056c-.221-.09-.381-.185-.485-.303a.599.599 0 01-.149-.418c0-.133.028-.298.126-.448.1-.152.265-.279.522-.34l.123-.03v1.595zm1.057 3.678v-1.732l.147.08a.934.934 0 01.376.346.936.936 0 01.122.483.9.9 0 01-.096.429.744.744 0 01-.414.343l-.135.05z"
      fill="currentColor"
    ></path>
  </svg>
)

export const AccountStatementLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M11.336 8.577c-.769.15-1.1.558-1.1 1.146 0 .573.331.874 1.1 1.086V8.577zM12.678 15.393c.71-.196 1.041-.663 1.041-1.236 0-.438-.18-.89-1.04-1.147v2.383z"
      fill="currentColor"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21a9 9 0 100-18 9 9 0 000 18zm.86-3.948V18.5h-1.72v-1.387c-1.523-.136-2.533-.755-3.287-1.584l1.357-1.237c.573.604 1.282 1.01 2.126 1.131V12.71c-2.262-.468-3.182-1.463-3.182-2.926 0-1.583 1.04-2.64 2.986-2.865V5.5h1.72v1.418c1.206.135 2.096.603 2.76 1.357l-1.373 1.237c-.362-.408-.845-.74-1.569-.905v2.503c2.112.483 3.122 1.342 3.122 2.88 0 1.479-.935 2.73-2.94 3.062z"
      fill="currentColor"
    ></path>
  </svg>
)

export const AccountMarginWalletsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7678 7.01874L5.82854 19.958L4.06077 18.1902L17 5.25098L17.8839 6.13486L18.7678 7.01874Z"
      fill="currentColor"
    ></path>
    <path d="M12 4H20V12L12 4Z" fill="currentColor"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 11C9.433 11 11 9.433 11 7.5C11 5.567 9.433 4 7.5 4C5.567 4 4 5.567 4 7.5C4 9.433 5.567 11 7.5 11ZM7.5 5.96875L5.96875 7.5L7.5 9.03125L9.03125 7.50017L7.5 5.96875Z"
      fill="currentColor"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 20C18.433 20 20 18.433 20 16.5C20 14.567 18.433 13 16.5 13C14.567 13 13 14.567 13 16.5C13 18.433 14.567 20 16.5 20ZM16.5 14.9688L14.9688 16.5L16.5 18.0312L18.0312 16.5002L16.5 14.9688Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const ThreeDotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M10 10h4v4h-4v-4zM17 10h4v4h-4v-4zM3 10h4v4H3v-4z" fill="currentColor"></path>
  </svg>
)
export const ThreeEmptyDotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="48" viewBox="0 0 24 48" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="8" r="4" fill="none" stroke="#ffffff" strokeWidth="2" />
    <circle cx="12" cy="24" r="4" fill="none" stroke="#ffffff" strokeWidth="2" />
    <circle cx="12" cy="40" r="4" fill="none" stroke="#ffffff" strokeWidth="2" />
  </svg>
)

export const SelectArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M16.5 8.49v2.25L12 15.51l-4.5-4.77V8.49h9z" fill="currentColor"></path>
  </svg>
)

export const BuyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 13.83A6.97 6.97 0 0015 9.5a6.97 6.97 0 00-1.5-4.33 5 5 0 110 8.662zM3 16.5h18v3H3v-3zm10-7a5 5 0 11-10 0 5 5 0 0110 0zm-7 0l2-2 2 2-2 2-2-2z"
      fill="currentColor"
    ></path>
  </svg>
)

export const SellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 3.5a5.502 5.502 0 00-5.302 4.032 7.502 7.502 0 016.77 6.77A5.502 5.502 0 0015 3.5zM14.5 15a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-8 0L9 17.5l2.5-2.5L9 12.5 6.5 15zM9 4H4v5l5-5zm11 16h-5l5-5v5z"
      fill="currentColor"
    ></path>
  </svg>
)

export const DepositIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M13.5 3h-3v6.95l-.303-.003-4.159.04 5.975 5.976 5.975-5.975-4.176-.01-.312-.002V3zm-10 11h3v4h11v-4h3v7h-17v-7z"
      fill="currentColor"
    ></path>
  </svg>
)

export const WithdrawIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M10.5 15.963h3V8.987l.312-.003 4.176-.01L12.013 3 6.038 8.975l4.159.04.303-.002v6.95zM6.5 14h-3v7h17v-7h-3v4h-11v-4z"
      fill="currentColor"
    ></path>
  </svg>
)

export const TradeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 3.5a5.502 5.502 0 00-5.302 4.032 7.502 7.502 0 016.77 6.77A5.502 5.502 0 0015 3.5zM14.5 15a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-8 0L9 17.5l2.5-2.5L9 12.5 6.5 15z"
      fill="currentColor"
    ></path>
  </svg>
)

export const ConvertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M14 3h7v7l-7-7z" fill="currentColor"></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6a6 6 0 100 12 6 6 0 000-12zm0 8.4l2.4-2.4L12 9.6 9.6 12l2.4 2.4z"
      fill="currentColor"
    ></path>
    <path d="M3 21h7l-7-7v7z" fill="currentColor"></path>
  </svg>
)

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6a5 5 0 110 10 5 5 0 010-10zm0-3a8 8 0 017.021 11.838l3.07 3.07-1.59 1.591-1.591 1.591-3.07-3.07A8 8 0 1111 3z"
      fill="currentColor"
    ></path>
  </svg>
)
